<div #galleryRef [id]="galleryId"></div>
